import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Template_2.css";
import Template_2_Header from "./Template_2_Header";
import Template_2_HeroSection from "./Template_2_HeroSection";
import Template_2_TravelTypes from "./Template_2_TravelTypes";
import Template_2_Packages from "./Template_2_Packages";
import Template_2_Reviews from "./Template_2_Reviews";
import Template_2_AboutUs from "./Template_2_AboutUs";
import Template_2_Footer from "./Template_2_Footer";
import Template_2_EnquiryPopup from "./Template_2_EnquiryPopup";
import Template_2_Advertisements from "./Template_2_Advertisements";
import Template_2_TopHeader from "./Template_2_TopHeader";

const Template_2_HomePage = () => {
  const [showEnquiryPopup, setShowEnquiryPopup] = useState(false);
  const [enquiryPackage, setEnquiryPackage] = useState(null);

  const handleEnquireClick = (pkg) => {
    setEnquiryPackage(pkg);
    setShowEnquiryPopup(true);
  };

  const handleCloseEnquiry = () => {
    setShowEnquiryPopup(false);
    setEnquiryPackage(null);
  };

  return (
    <div className="Template_2 homepage-template-2">
      {/* TopHeader */}
      <Template_2_TopHeader />
      {/* Header */}
      <Template_2_Header />
      {/* Hero Section */}
      <Template_2_HeroSection />
      {/* Advertisements Section */}
      <Template_2_Advertisements />
      {/* Travel Types */}
      <Template_2_TravelTypes />

      {/* Packages Section */}
      <Template_2_Packages onEnquireClick={handleEnquireClick} />
      {/* Reviews */}
      <Template_2_Reviews />
      {/* About Us */}
      <Template_2_AboutUs />
      {/* Footer */}
      <Template_2_Footer />
      {/* Enquiry Popup */}
      {showEnquiryPopup && enquiryPackage && (
        <Template_2_EnquiryPopup
          packageDetails={enquiryPackage}
          onClose={handleCloseEnquiry}
        />
      )}
    </div>
  );
};

export default Template_2_HomePage;
